import { ActionType } from './flags';
import { action } from 'typesafe-actions';

export const setAppFlags = flagsObj => {
  return async dispatch => {
    dispatch(action(ActionType.SET_FLAGS, flagsObj));
  };
};
